import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get category data data */
export const getCategoryList = async () => {
  const res = await get(`/external-api/get_all_categories`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetCategoryList = (onSuccess: any, onError: any) => {
  return useQuery('video-categories', getCategoryList, {
    refetchOnWindowFocus: false,
    enabled: true,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetCategoryList;
